<template>
  <div v-loading="isLoading">
    <el-row class="title-bar" type="flex" justify="end">
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </el-row>
    <el-row class="gray-box mr-b10" v-show="showSearchTool" type="flex" justify="start">
      <div>
        <span class="tit" >장비명</span>
        <el-input class="mr-r15" style="width: 150px;" v-model="objName" clearable @keyup.enter.native="clickSearchBtn"></el-input>
        <span class="tit">IP</span>
        <el-input v-model="ipaddress" clearable style="width: 150px;" @keyup.enter.native="clickSearchBtn"></el-input>
      </div>
      <el-button class="mr-l4" @click="clickSearchBtn">검색</el-button>
    </el-row>
    <ul class="list list-event">
      <li v-for="data in perfData" :key="data.objId" :style="{borderColor: data.eventlevelColor}">
        <div v-if="data.objDefineId === 'SERVER'">
          <span>{{ data.objName }}</span>
          <span>{{ data.ipaddress }}</span>
          <span v-if="!isNil(data.objtypeName)">{{ data.objtypeName }}</span><span v-else>{{ EMPTY_TEXT }}</span>
          <template v-for="(rscInfo, index) in data.rscInfos">
            <span v-if="index === 0" :key="`${data.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
              <b>운영상태</b> {{ setElementStatusLabel(rscInfo.rscValue) }}
            </span>
            <span v-else :key="`${data.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
              <b>{{ rscInfo.rscName }}</b> {{ convertValuByUnit(getValueAfterCheckEmpty(rscInfo.rscValue), rscInfo.rscUnit, true, true, false) }}
            </span>
          </template>
        </div>
        <div v-else-if="data.objDefineId === 'NETDEVICE'">
          <span>{{ data.objName }}</span>
          <span>{{ data.ipaddress }}</span>
          <span>{{ data.objtypeName }}</span>
          <template v-for="(rscInfo, index) in data.rscInfos">
            <span v-if="index === 0" :key="`${data.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
              <b>운영상태</b> {{ setElementStatusLabel(rscInfo.rscValue) }}
            </span>
            <span v-else :key="`${data.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
              <b>{{ rscInfo.rscName }}</b> {{ convertValuByUnit(getValueAfterCheckEmpty(rscInfo.rscValue), rscInfo.rscUnit, true, true, false) }}
            </span>
          </template>
        </div>
        <div v-else-if="data.objDefineId === 'WIRELESS_DEVICE'">
          <span>{{ data.objName }}</span>
          <span>{{ data.ipaddress }}</span>
          <span>{{ data.objtypeName }}</span>
          <template v-for="(rscInfo, index) in data.rscInfos">
            <span v-if="index === 0" :key="`${data.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
              <b>운영상태</b> {{ setElementStatusLabel(rscInfo.rscValue) }}
            </span>
            <span v-else :key="`${data.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
              <b>{{ rscInfo.rscName }}</b> {{ convertValuByUnit(getValueAfterCheckEmpty(rscInfo.rscValue), rscInfo.rscUnit, true, true, false) }}
            </span>
          </template>
        </div>
        <div v-else-if="data.objDefineId === 'NETINTERFACE'">
          <span>{{ data.objName }}</span>
          <span v-if="!isNil(data.netinterfaceSpeed)">
           <b>대역폭</b> {{ convertValueForInterfaceSpeed(data.netinterfaceSpeed) }}</span><span v-else>{{ EMPTY_TEXT }}
          </span>
          <!-- <span v-if="!isNil(data.netinterfaceStatusAdmin)">{{ getInterfaceStatus(data.netinterfaceStatusAdmin) }}</span><span v-else>{{ EMPTY_TEXT }}</span>
          <span v-if="!isNil(data.netinterfaceStatusOper)">{{ getInterfaceStatus(data.netinterfaceStatusOper) }}</span><span v-else>{{ EMPTY_TEXT }}</span> -->
          <span v-if="!isNil(data.parentObjName)">{{ data.parentObjName }}</span><span v-else>{{ EMPTY_TEXT }}</span>
          <span v-if="!isNil(data.parentIpaddress)">{{ data.parentIpaddress }}</span><span v-else>{{ EMPTY_TEXT }}</span>
          <template v-for="(rscInfo, index) in data.rscInfos">
            <span v-if="index === 0" :key="`${data.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
              <b>운영상태</b> {{ setElementStatusLabel(rscInfo.rscValue) }}
            </span>
            <span v-else :key="`${data.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
              <b>{{ rscInfo.rscName }}</b> {{ convertValuByUnit(getValueAfterCheckEmpty(rscInfo.rscValue), rscInfo.rscUnit, true, true, false) }}
            </span>
          </template>
        </div>
        <div v-else-if="data.objDefineId === 'DBMS' || data.objDefineId === 'WAS'">
          <span>{{ data.objName }}</span>
          <span>{{ data.ipaddress }}</span>
          <span>{{ data.objtypeName }}</span>
          <template v-for="rscInfo in data.rscInfos">
            <!-- DBMS 운영상태 미설계로 표현 불가 -->
            <!-- <span v-if="index === 0" :key="`${data.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
              <b>운영상태</b> {{ setElementStatusLabel(rscInfo.rscValue) }}
            </span>
            <span v-else :key="`${data.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
              <b>{{ rscInfo.rscName }}</b> {{ convertValuByUnit(getValueAfterCheckEmpty(rscInfo.rscValue), rscInfo.rscUnit, true, true, false) }}
            </span> -->
            <span :key="`${data.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
              <b>{{ rscInfo.rscName }}</b> {{ convertValuByUnit(getValueAfterCheckEmpty(rscInfo.rscValue), rscInfo.rscUnit, true, true, false) }}
            </span>
          </template>
        </div>
        <div v-else-if="data.objDefineId === 'FMS_SENSOR'">
          <span>{{ data.objName }}</span>
          <span>{{ data.parentIpaddress }}</span>
          <template v-for="(rscInfo, index) in data.rscInfos">
            <span v-if="index === 0" :key="`${data.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
              <b>{{ rscInfo.rscName }}</b> {{ setElementStatusLabel(rscInfo.rscValue) }}
            </span>
            <span v-else :key="`${data.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
              <b>{{ rscInfo.rscName }}</b> {{ convertValuByUnit(getValueAfterCheckEmpty(rscInfo.rscValue), rscInfo.rscUnit, true, true, false) }}
            </span>
          </template>
        </div>
        <div v-else-if="data.objDefineId === 'E2E_SERVICE'">
          <span>{{ data.objName }}</span>
          <span>{{ data.protocol }}</span>
          <span>E2E 에이전트 정보 [</span>
            <div v-for="agentInfo in data.agentInfos" :key="agentInfo.index" style="display: contents">
              <span><b>{{ agentInfo.objName }}</b></span>
              <span style="background: none">(</span>
              <template v-for="(rscInfo, index) in agentInfo.rscInfos">
                <span v-if="index === 0" :key="`${data.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
                  <b>운영상태</b> {{ setElementStatusLabel(rscInfo.rscValue) }}
                </span>
                <span v-else :key="`${data.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
                  <b>{{ rscInfo.rscName }}</b> {{ convertValuByUnit(rscInfo.rscValue, rscInfo.rscUnit, true, true, false) }}
                </span>
              </template>
              <span>)</span>
            </div>
          <span>]</span>
        </div>
        <div v-else-if="data.objDefineId === 'SERVICE'">
          <span>{{ data.objName }}</span>
          <span>서비스 구성 정보 [</span>
            <template v-for="elementInfo in data.elementInfos">
              <div v-if="elementInfo.objDefineId === 'E2E_SERVICE'" :key="elementInfo.index" style="display: contents">
                <span><b>{{ elementInfo.objName }}</b></span>
                <span style="background: none">(</span>
                <div v-for="agentInfo in elementInfo.agentInfos" :key="agentInfo.index" style="display: contents">
                  <span><b>{{ agentInfo.objName }}</b></span>
                  <span style="background: none">(</span>
                  <template v-for="(rscInfo, index) in agentInfo.rscInfos">
                    <span v-if="index === 0" :key="`${data.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
                      <b>운영상태</b> {{ setElementStatusLabel(rscInfo.rscValue) }}
                    </span>
                    <span v-else :key="`${data.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
                      <b>{{ rscInfo.rscName }}</b> {{ convertValuByUnit(rscInfo.rscValue, rscInfo.rscUnit, true, true, false) }}
                    </span>
                  </template>
                  <span>)</span>
                </div>
              </div>
              <div v-else :key="elementInfo.index" style="display: contents">
                <span><b>{{ elementInfo.objName }}</b></span>
                <span style="background: none">(</span>
                <template v-for="(rscInfo, index) in elementInfo.rscInfos">
                  <span v-if="index === 0 && elementInfo.objDefineId != 'DBMS'" :key="`${elementInfo.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
                    <b>운영상태</b> {{ setElementStatusLabel(rscInfo.rscValue) }}
                  </span>
                  <span v-else :key="`${elementInfo.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
                    <b>{{ rscInfo.rscName }}</b> {{ convertValuByUnit(rscInfo.rscValue, rscInfo.rscUnit, true, true, false) }}
                  </span>
                </template>
                <span>)</span>
              </div>
            </template>
          <span>]</span>
        </div>
        <div v-else-if="data.objDefineId === 'VMS_OBJECT'">
          <span>{{ data.objName }}</span>
          <span v-if="!isNil(data.ipaddress)">{{ data.ipaddress }}</span>
          <span v-if="!isNil(data.objtypeName)">{{ data.objtypeName }}</span><span v-else>{{ EMPTY_TEXT }}</span>
          <template v-for="(rscInfo, index) in data.rscInfos">
            <span v-if="data.objtypeId === 'VVM' && index === 0" :key="`${data.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
              <b>운영 상태</b> {{ setElementStatusLabel(rscInfo.rscValue) }}
            </span>
            <span v-else :key="`${data.objId}.${rscInfo.rsctypeId}.${rscInfo.rscId}`" :style="{color: rscInfo.eventlevelColor}">
              <b>{{ rscInfo.rscName }}</b> {{ convertValuByUnit(getValueAfterCheckEmpty(rscInfo.rscValue), rscInfo.rscUnit, true, true, false) }}
            </span>
          </template>
        </div>
      </li>
    </ul>
    <el-row class="mr-t10" type="flex" justify="center">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        background
        :current-page.sync="currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next"
        :total="totalPerfData">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
import keys from 'lodash/keys';
import { isNil, isEqual, isEmpty } from 'lodash';
import { convertValueForInterfaceSpeed, convertValuByUnit } from '@/utils/number';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { OBJDEFINE } from '@/constants/objdefine';
import { mapGetters } from 'vuex';
import commonApi from '@/api/performance/common';
import { defaultPagination } from '@/constants/table';

export default {
  name: 'WAllPerfList',
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      OBJDEFINE,
      EMPTY_TEXT,
      params: {
        managegroupIds: [],
        objDefineIds: [],
      },
      objName: '',
      ipaddress: '',
      showSearchTool: false,
      perfData: [],
      totalPerfData: 0,
      currentPage: 1,
      pageSize: defaultPagination.pageSize,
      pageSizes: defaultPagination.pageSizes,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters(['selectedNode', 'selectedObjDefineIds']),
    treeType() {
      return this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
    },
  },
  watch: {
    selectedNode: {
      handler() {
        this.showSearchTool = false;
        this.objName = '';
        this.ipaddress = '';
        this.$nextTick(() => {
          this.params.start = 0; // 선택한 노드 변경할 때마다 페이징 start값 초기화
          this.currentPage = 1; // 선택한 노드 변경할 때마다 첫 번째 페이지로 초기화
        });
        this.loadStore();
      },
    },
    selectedObjDefineIds: {
      handler() {
        this.loadStore();
      },
      immediate: true,
    },
    active: {
      handler() {
        this.loadStore();
      },
    },
  },
  methods: {
    isNil,
    convertValuByUnit,
    getValueAfterCheckEmpty,
    convertValueForInterfaceSpeed,
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadStore();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadStore();
    },
    loadStore() {
      if (this.active) {
        this.params.treeType = this.treeType;
        if (isEqual(this.treeType, 'physical')) {
          this.params.start = (this.currentPage * this.pageSize) - this.pageSize;
          this.params.limit = this.pageSize;
          this.params.objDefineIds = this.selectedObjDefineIds.length === 0 ? keys(OBJDEFINE) : this.selectedObjDefineIds;
          this.setSearchParams();
          this.isLoading = true;
          commonApi.getGroupPerformanceInfo(this.params).then((response) => {
            if (response.data.success) {
              this.totalPerfData = response.data.total;
              this.perfData = response.data.data;
            }
          }).finally(() => {
            this.isLoading = false;
          });
        } else if (isEqual(this.treeType, 'logical')) {
          if (!isEmpty(this.selectedNode.childManagegroupIds)) {
            this.params.managegroupIds = this.selectedNode.childManagegroupIds;
          }
          this.params.start = (this.currentPage * this.pageSize) - this.pageSize;
          this.params.limit = this.pageSize;
          this.params.objDefineIds = this.selectedObjDefineIds.length === 0 ? keys(OBJDEFINE) : this.selectedObjDefineIds;
          this.setSearchParams();
          this.isLoading = true;
          commonApi.getGroupPerformanceInfo(this.params).then((response) => {
            if (response.data.success) {
              if (!isEmpty(response.data.data)) {
                this.totalPerfData = response.data.total;
                this.perfData = response.data.data;
              } else {
                this.totalPerfData = 0;
                this.perfData = [];
              }
            }
          }).finally(() => {
            this.isLoading = false;
          });
        }
      }
    },
    setElementStatusLabel(status) {
      if (isNil(status)) {
        return EMPTY_TEXT;
      } else if (status === '1') {
        return 'UP';
      } else if (status === '0') {
        return 'DOWN';
      }
      return status;
    },
    clickSearchBtn() {
      this.currentPage = 1;
      this.loadStore();
    },
    setSearchParams() {
      const searchParams = [];
      if (this.objName) {
        searchParams.push(
          {
            field: 'objName',
            value: this.objName,
          },
        );
      }
      if (this.ipaddress) {
        searchParams.push(
          {
            field: 'ipaddress',
            value: this.ipaddress,
          },
        );
      }
      this.params.searchParams = searchParams;
    },
    getInterfaceStatus(value) {
      if (value === 1) {
        return 'UP';
      } else if (value === 2) {
        return 'DOWN';
      }
      return EMPTY_TEXT;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/group/perfinfo/components/AllPerfList.vue